import SDUProductPage from 'components/ProductPage/Type/DigitalProduct/SDUProductPage/SDUProductPage';
import { withSDUProductPageProps } from 'viewModel/productPage/type/digitalProduct/sduProductPage/withSDUProductPageProps';

export default withSDUProductPageProps(SDUProductPage);
